export const RETENTION_PALETTE = [
  '#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399',
  '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF',
  '#FF9F40', '#8E44AD', '#2ECC71', '#F1C40F', '#E74C3C',
  '#1ABC9C', '#3498DB', '#9B59B6', '#34495E', '#7F8C8D'
]
